import { writable } from 'svelte/store';

import { key, storeValue } from './_util';
import { safeLocalStorage } from '../utils/window';

const initialData = null;

const createBbpUserStore = () => {
  const { subscribe, set } = writable(initialData);
  const data = safeLocalStorage().getItem(key + 'bbp_user');
  if (data) {
    try {
      set(JSON.parse(data));
    } catch (err) {
      safeLocalStorage().removeItem(key + 'bbp_user');
    }
  }

  subscribe(data => {
    safeLocalStorage().setItem(key + 'bbp_user', JSON.stringify(data));
    storeValue(key + 'BBP_LOGGED_IN', data !== null);
  });

  return {
    subscribe,
    set,
    reset: () => set(initialData),
  };
};

export default createBbpUserStore();
